import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import { FormControl } from '@material-ui/core';
import { Map } from 'immutable';

import FormTextField from 'retired/FormTextField';

import FormFieldLabel from '../FormFieldLabel/index';

import LikertNumberOfOptionsSelector from './LikertNumberOfOptionsSelector';

const LikertOptions = ({ fields, meta: { error, submitFailed } }) => (
  <div style={{ paddingLeft: 15 }}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <FormFieldLabel>Number of options: </FormFieldLabel>
      <FormControl style={{ marginLeft: 15 }}>
        <LikertNumberOfOptionsSelector
          value={fields.length}
          onChange={(event) => {
            fields.removeAll();
            [...Array(parseInt(event.target.value, 10)).keys()].forEach(() =>
              fields.push(new Map({ title: '' }))
            );
          }}
        />
      </FormControl>
    </div>
    {submitFailed && error && <span>{error}</span>}
    {fields.map((option, index) => (
      <div key={option} style={{ display: 'flex', alignItems: 'center' }}>
        <FormFieldLabel>Label {index + 1}: </FormFieldLabel>
        <FormControl style={{ flexGrow: 1, marginLeft: 15 }}>
          <Field
            name={`${option}.title`}
            component={FormTextField}
            title={`Label ${index + 1}`}
            value={option}
          />
        </FormControl>
      </div>
    ))}
  </div>
);
LikertOptions.propTypes = {
  fields: PropTypes.any,
  meta: PropTypes.any,
};
export default LikertOptions;
